var render = function render(){
  var _vm$global$profile;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-grow-1 d-flex flex-column overflow-hidden"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload",
    attrs: {
      "type": "file",
      "accept": "image/*,image/heic"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.loadMediaStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.addMediaFromDataURLStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.deleteMediaStatus
    }
  }), _vm.promptColor ? _c('color-prompt', {
    attrs: {
      "value": _vm.promptColor.value
    },
    on: {
      "input": function (v) {
        return _vm.promptColor.eager && _vm.promptColor.callback(v);
      },
      "close": function (v) {
        _vm.promptColor.callback(v);
        _vm.promptColor = null;
      }
    }
  }) : _vm._e(), _vm.promptStamp ? _c('custom-stamp-prompt', {
    ref: "stamp",
    attrs: {
      "opts": _vm.promptStamp
    },
    on: {
      "save": function (v, r) {
        return _vm.addMediaFromDataURL(_vm.promptStamp.file.name, 'stamp', v).then(r);
      },
      "input": function (v) {
        return _vm.set({
          env_stamp: v
        });
      },
      "close": function ($event) {
        _vm.promptStamp = null;
      }
    }
  }) : _vm._e(), _c('sign-in-dialog', {
    ref: "sign-in",
    scopedSlots: _vm._u([{
      key: "subtitle",
      fn: function () {
        return [_vm._v("Please sign in to upload custom media")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _vm.selected == 'LOGO' && !((_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.org_id) ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column grey lighten-4"
  }, [_c('v-card-title', {
    staticClass: "d-block grey--text mb-1",
    staticStyle: {
      "line-height": "1.4em"
    }
  }, [_c('v-btn', {
    staticClass: "float-right mr-n3 mt-n1",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-icon', {
    attrs: {
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" Organization account required ")], 1), _c('v-card-subtitle', [_vm._v(" Customizing / removing the logo is only available for "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'start-business'
      }
    }
  }, [_vm._v("business customers")]), _vm._v(". Create an Ellacard organization to continue (no payment required). ")], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-5 white"
  }, [_c('org-sign-up-form', {
    on: {
      "cancel": function ($event) {
        _vm.selected = null;
      }
    }
  })], 1)], 1)], 1) : _vm.selected == 'LOGO' ? _c('dialog-scroll-lock-loader', {
    attrs: {
      "width": "400",
      "loading": _vm.loadCustomMediaStatus.pending,
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column",
    attrs: {
      "max-height": "90vh"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center pa-3"
  }, [_c('div', {
    staticClass: "title pl-1"
  }, [_vm._v("Logo")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0 mr-2",
    attrs: {
      "hide-details": "",
      "input-value": _vm.isActive('LOGO')
    },
    nativeOn: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return function () {
          return _vm.isActive('LOGO') && _vm.set({
            header_logo: _vm.orgHas('header_logo') ? _vm.orgSkin.header_logo : _vm.DEFAULT.header_logo,
            email_footer_logo: _vm.orgHas('email_footer_logo') ? _vm.orgSkin.email_footer_logo : _vm.DEFAULT.email_footer_logo,
            email_footer_url: _vm.orgHas('email_footer_url') ? _vm.orgSkin.email_footer_url : _vm.DEFAULT.email_footer_url
          });
        }.apply(null, arguments);
      }
    }
  }), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v("Done")])], 1), _c('v-tabs', {
    attrs: {
      "grow": "",
      "value": ['header_logo', 'email_footer_logo'].indexOf(_vm.logoKey)
    },
    on: {
      "change": function (v) {
        return _vm.logoKey = ['header_logo', 'email_footer_logo'][v];
      }
    }
  }, [_c('v-tab', {
    staticClass: "text--label-active",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCellphoneLink)
    }
  }), _vm._v("Web ")], 1), _c('v-tab', {
    staticClass: "text--label-active",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTextBox)
    }
  }), _vm._v("Email ")], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "pt-4 px-4 pb-2"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "contain": "",
      "max-width": "240",
      "aspect-ratio": 16 / 9,
      "src": _vm.order.skin[_vm.logoKey]
    }
  }, [!_vm.order.skin[_vm.logoKey] ? _c('div', {
    staticClass: "fill-height d-flex align-center justify-center text-center font-italic grey--text"
  }, [_vm._v(" No image ")]) : _vm._e()])], 1), _c('v-card-text', {
    staticClass: "flex-shrink-1 py-6 overflow-auto"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    class: {
      active: !_vm.order.skin[_vm.logoKey]
    },
    style: {
      outline: _vm.order.skin[_vm.logoKey] ? '2px dashed #E0E0E0 !important' : null
    },
    attrs: {
      "hover": "",
      "disabled": _vm.orgHas(_vm.logoKey)
    },
    on: {
      "click": function ($event) {
        var _vm$set;
        return _vm.set((_vm$set = {}, _vm$set[_vm.logoKey] = null, _vm$set));
      }
    }
  }, [_c('v-responsive', {
    staticClass: "white pa-1",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticStyle: {
      "outline": "2px dashed #E0E0E0 !important"
    },
    attrs: {
      "hover": "",
      "color": "grey lighten-5",
      "disabled": _vm.orgHas(_vm.logoKey)
    },
    on: {
      "click": function ($event) {
        return _vm.promptImage(_vm.onUploadLogo);
      }
    }
  }, [_c('v-responsive', {
    staticClass: "overflow-visible pa-1",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('div', {
    staticClass: "fill-height d-flex align-center justify-center text-center text--label-active pa-3"
  }, [_vm._v(" Add custom image… ")]), _c('v-btn', {
    staticStyle: {
      "right": "-12px",
      "bottom": "-12px"
    },
    attrs: {
      "absolute": "",
      "fab": "",
      "small": "",
      "loading": _vm.addMediaFromDataURLStatus.pending
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  })], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-card', {
    staticClass: "v-card--link",
    class: {
      active: _vm.order.skin[_vm.logoKey] == _vm.DEFAULT[_vm.logoKey]
    },
    attrs: {
      "flat": "",
      "disabled": _vm.orgHas(_vm.logoKey)
    },
    on: {
      "click": function ($event) {
        return _vm.setLogo(_vm.DEFAULT[_vm.logoKey]);
      }
    }
  }, [_c('v-responsive', {
    staticClass: "overflow-visible pa-1",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('v-img', {
    staticClass: "stamp-preview",
    attrs: {
      "contain": "",
      "aspect-ratio": 16 / 9,
      "src": _vm.DEFAULT[_vm.logoKey]
    }
  })], 1)], 1)], 1), _vm._l(_vm.customMedia.logo, function (l) {
    return _c('v-col', {
      key: l.url,
      staticClass: "relative",
      attrs: {
        "cols": "6"
      }
    }, [_c('v-card', {
      staticClass: "v-card--link",
      class: {
        active: _vm.order.skin[_vm.logoKey] == l.url
      },
      attrs: {
        "flat": "",
        "disabled": _vm.orgHas(_vm.logoKey)
      },
      on: {
        "click": function ($event) {
          return _vm.setLogo(l.url);
        }
      }
    }, [_c('v-responsive', {
      staticClass: "overflow-visible pa-1",
      attrs: {
        "aspect-ratio": 16 / 9
      }
    }, [_c('v-img', {
      staticClass: "stamp-preview",
      attrs: {
        "contain": "",
        "aspect-ratio": 16 / 9,
        "src": l.url
      }
    })], 1)], 1), _c('v-btn', {
      staticStyle: {
        "right": "0",
        "bottom": "0"
      },
      attrs: {
        "absolute": "",
        "fab": "",
        "small": "",
        "loading": _vm.deletingMedia == l.name
      },
      on: {
        "click": function ($event) {
          _vm.deleteMedia('logo', l.name).then(function (x) {
            if (x) {
              if (!_vm.orgHas('header_logo') && _vm.order.skin.header_logo == l.url) _vm.order.skin.header_logo = null;
              if (!_vm.orgHas('email_footer_logo') && _vm.order.skin.email_footer_logo == l.url) _vm.order.skin.email_footer_logo = null;
            }
          });
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "warning"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiDelete)
      }
    })], 1)], 1);
  })], 2)], 1), _c('div', {
    staticClass: "px-5"
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.orgHas('header_logo') || _vm.orgHas('email_footer_logo')
    },
    on: {
      "change": function ($event) {
        return _vm.setLogo(_vm.order.skin[_vm.logoKey]);
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "text-body-2"
        }, [_vm._v("Use same for web and email")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.useSameLogo,
      callback: function ($$v) {
        _vm.useSameLogo = $$v;
      },
      expression: "useSameLogo"
    }
  })], 1), _c('v-card-text', {
    staticClass: "overflow-hidden",
    staticStyle: {
      "height": "80px"
    }
  }, [_vm.logoKey == 'email_footer_logo' ? _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Logo hyperlink",
      "placeholder": "http…",
      "disabled": !_vm.order.skin.email_footer_logo || _vm.orgHas('email_footer_logo'),
      "rules": [function (v) {
        return v && v.startsWith('http');
      }],
      "value": _vm.order.skin.email_footer_logo ? _vm.order.skin.email_footer_url : '-'
    },
    on: {
      "input": function (v) {
        return v && v.startsWith('http') && _vm.set({
          email_footer_url: v
        });
      }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm.selected == 'BG' ? _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "fill-height",
      "width": "600",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex align-center pa-3"
  }, [_c('div', {
    staticClass: "title pl-1"
  }, [_vm._v("Background")]), _c('v-spacer'), !_vm.orgHas('page_background_color') ? _c('v-switch', {
    staticClass: "mt-0 mr-2",
    attrs: {
      "hide-details": "",
      "input-value": _vm.isActive('BG')
    },
    nativeOn: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return function () {
          return _vm.isActive('BG') && _vm.set({
            page_background_color: _vm.DEFAULT.page_background_color,
            page_background_img: _vm.DEFAULT.page_background_img
          });
        }.apply(null, arguments);
      }
    }
  }) : _vm._e(), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v("Done")])], 1), _c('v-divider'), _c('div', {
    staticClass: "px-6 py-5"
  }, [_c('div', {
    staticClass: "mx-auto relative",
    staticStyle: {
      "max-width": "200px"
    }
  }, [_c('v-menu', {
    attrs: {
      "absolute": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-card', _vm._g(_vm._b({
          attrs: {
            "hover": "",
            "color": _vm.order.skin.page_background_color || '#FFF'
          }
        }, 'v-card', attrs, false), on), [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 16 / 9
          }
        }, [_vm.order.skin.page_background_img ? _c(_vm.order.skin.page_background_img.endsWith('.mp4') ? 'video' : 'img', {
          key: _vm.order.skin.page_background_img,
          tag: "component",
          staticClass: "absolute loading-icon",
          staticStyle: {
            "object-fit": "cover"
          },
          attrs: {
            "width": "100%",
            "height": "100%",
            "playsinline": "",
            "autoplay": "",
            "muted": "",
            "loop": "",
            "src": _vm.order.skin.page_background_img
          },
          on: {
            "load": function (e) {
              return e.target.classList.add('loaded');
            },
            "loadeddata": function (e) {
              return e.target.classList.add('loaded');
            }
          }
        }) : _vm._e()], 1)], 1)];
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm.order.skin.page_background_img ? _c('v-list-item', {
    on: {
      "click": function ($event) {
        return _vm.set({
          page_background_img: null
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  }), _c('v-list-item-title', [_vm._v("Remove image")])], 1) : !_vm.noCustomMedia ? _c('v-list-item', {
    on: {
      "click": function ($event) {
        return _vm.promptImage(_vm.onUploadBackground);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  }), _c('v-list-item-title', [_vm._v("Upload image…")])], 1) : _vm._e(), !_vm.orgHas('page_background_color') ? _c('v-list-item', {
    on: {
      "click": function ($event) {
        _vm.promptColor = {
          value: _vm.order.skin.page_background_color,
          eager: true,
          callback: function (v) {
            return _vm.set({
              page_background_color: v
            });
          }
        };
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPalette)
    }
  }), _c('v-list-item-title', [_vm._v("Set color…")])], 1) : _vm._e()], 1)], 1), !_vm.orgHas('page_background_color') ? _c('v-btn', {
    staticStyle: {
      "right": "-8px",
      "bottom": "-8px"
    },
    attrs: {
      "absolute": "",
      "color": _vm.order.skin.page_background_color || '#FFF'
    },
    on: {
      "click": function ($event) {
        _vm.promptColor = {
          value: _vm.order.skin.page_background_color,
          eager: true,
          callback: function (v) {
            return _vm.set({
              page_background_color: v
            });
          }
        };
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.getBrightness(_vm.order.skin.page_background_color || '#FFF') < 160 ? '#F5F5F5' : '#344558'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPalette)
    }
  })], 1) : _vm._e()], 1)]), _c('v-divider'), _vm.loadMediaStatus.pending || _vm.loadCustomMediaStatus.pending ? [_c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }), _c('v-spacer')] : [_c('div', {
    staticClass: "mt-2 mx-2 text--label-active"
  }, [_vm._v("Filters")]), _c('side-scroller', _vm._l(_vm.BG_FILTERS, function (_ref2, i) {
    var tag = _ref2[0],
      icon = _ref2[1];
    return _c('v-chip', {
      key: 'bg-' + tag,
      staticClass: "ma-1",
      class: {
        'primary--text': _vm.bgFilter == i
      },
      attrs: {
        "filter": "",
        "input-value": _vm.bgFilter == i
      },
      on: {
        "click": function ($event) {
          _vm.bgFilter = _vm.bgFilter == i ? 0 : i;
        }
      }
    }, [_vm._v(" " + _vm._s(tag) + " "), icon ? _c('v-icon', {
      staticClass: "ml-1",
      class: {
        'icon-animated': tag == 'Animated'
      },
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }) : _vm._e()], 1);
  }), 1), _c('v-virtual-scroll-grid', {
    staticClass: "flex-grow-1",
    attrs: {
      "bench": "1",
      "items": _vm.bgFilter ? _vm.media.background.filter(function (x) {
        return x.tags.includes(_vm.BG_FILTERS[_vm.bgFilter][0]);
      }) : [{
        default: true,
        url: null,
        color: _vm.DEFAULT.page_background_color
      }].concat(_vm.noCustomMedia ? [] : [null].concat(_vm.customMedia.background), _vm.media.background),
      "n": _vm.$vuetify.breakpoint.xsOnly ? 2 : 3,
      "aspect-ratio": 16 / 9,
      "padding": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var item = _ref3.item,
          index = _ref3.index;
        return [item ? [_c('v-card', {
          class: {
            active: _vm.order.skin.page_background_img == item.url
          },
          attrs: {
            "hover": ""
          },
          on: {
            "click": function ($event) {
              _vm.set({
                page_background_color: _vm.orgHas('page_background_color') ? _vm.orgSkin.page_background_color : item.color || _vm.DEFAULT.page_background_color,
                page_background_img: _vm.orgHas('page_background_img') ? _vm.orgSkin.page_background_img : item.url
              });
            }
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 16 / 9
          }
        }, [item.url ? _c(item.name.endsWith('.mp4') ? 'video' : 'img', {
          tag: "component",
          staticClass: "absolute",
          staticStyle: {
            "object-fit": "cover"
          },
          attrs: {
            "width": "100%",
            "height": "100%",
            "playsinline": "",
            "autoplay": "",
            "muted": "",
            "loop": "",
            "src": _vm.getBackgroundPreview(item)
          }
        }) : _vm._e()], 1)], 1), !item.default ? _c('v-btn', {
          staticStyle: {
            "right": "0",
            "bottom": "0"
          },
          attrs: {
            "absolute": "",
            "fab": "",
            "small": "",
            "loading": _vm.deletingMedia == item.name
          },
          on: {
            "click": function ($event) {
              _vm.deleteMedia('background', item.name).then(function (x) {
                if (x && _vm.order.skin.page_background_img == item.url) _vm.order.skin.page_background_img = null;
              });
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "warning"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiDelete)
          }
        })], 1) : _vm._e()] : _c('v-card', {
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "relative",
          staticStyle: {
            "outline": "2px dashed #E0E0E0 !important"
          },
          attrs: {
            "hover": "",
            "color": "grey lighten-5"
          },
          on: {
            "click": function ($event) {
              return _vm.promptImage(_vm.onUploadBackground);
            }
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 16 / 9
          }
        }, [_c('div', {
          staticClass: "fill-height d-flex align-center justify-center text-center text--label-active pa-3"
        }, [_vm._v(" Add custom image… ")])]), _c('v-btn', {
          staticStyle: {
            "right": "-12px",
            "bottom": "-12px"
          },
          attrs: {
            "absolute": "",
            "fab": "",
            "small": "",
            "loading": _vm.addMediaFromDataURLStatus.pending
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiUpload)
          }
        })], 1)], 1)];
      }
    }])
  })]], 2)], 1) : _vm.selected == 'CF' ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "300",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "overflow-hidden"
  }, [_c('div', {
    staticClass: "d-flex align-center pa-3"
  }, [_c('div', {
    staticClass: "title pl-1"
  }, [_vm._v("Confetti")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0 mr-2",
    attrs: {
      "hide-details": "",
      "input-value": _vm.isActive('CF')
    },
    on: {
      "change": function () {
        _vm.confetti.show = !_vm.confetti.show;
        _vm.setConfetti();
      }
    }
  }), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v("Done")])], 1), _c('v-divider'), _c('div', {
    staticClass: "px-4 pt-3"
  }, [_c('div', {
    staticClass: "d-flex align-center mb-6"
  }, [_c('div', {
    staticClass: "v-label theme--light",
    class: {
      'v-label--is-disabled': !_vm.confetti.show
    }
  }, [_vm._v("Preset")]), _c('v-select', {
    staticClass: "ml-4 mt-0 overline",
    attrs: {
      "hide-details": "",
      "dense": "",
      "solo": "",
      "items": ['None'].concat(_vm.EFFECT_NAMES),
      "value": _vm.selectedEffectPreset
    },
    on: {
      "input": _vm.selectEffectPreset
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "overline short"
        }, [_vm._v(_vm._s(item))])];
      }
    }])
  })], 1), _vm._l(['Density', 'Size', 'Wind', 'Gravity'], function (label) {
    return _c('v-slider', {
      key: label,
      attrs: {
        "min": "0",
        "max": "1",
        "step": ".01",
        "label": label,
        "disabled": !_vm.confetti.show
      },
      on: {
        "end": _vm.setConfetti
      },
      model: {
        value: _vm.confetti.opts[label.toLowerCase()],
        callback: function ($$v) {
          _vm.$set(_vm.confetti.opts, label.toLowerCase(), $$v);
        },
        expression: "confetti.opts[ label.toLowerCase() ]"
      }
    });
  }), _c('div', {
    staticClass: "v-label theme--light mt-1",
    class: {
      'v-label--is-disabled': !_vm.confetti.show
    }
  }, [_vm._v("Colors")])], 2), _c('div', {
    staticClass: "overflow-auto",
    staticStyle: {
      "height": "152px",
      "padding": "6px"
    }
  }, [_vm._l(_vm.confetti.opts.colors, function (c, i) {
    return _c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      key: i + '-' + c,
      staticClass: "ma-2 relative",
      style: {
        background: c
      },
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": _vm.confetti.show ? null : 1
      },
      on: {
        "click": function () {
          if (_vm.confetti.show) _vm.promptColor = {
            value: c,
            callback: function (v) {
              _vm.$set(_vm.confetti.opts.colors, i, v);
              _vm.setConfetti();
            }
          };
        }
      }
    }, [_vm.confetti.show && _vm.confetti.opts.colors.length > 1 ? _c('v-btn', {
      staticStyle: {
        "top": "-28px",
        "right": "-16px",
        "transform": "scale(.5)"
      },
      attrs: {
        "absolute": "",
        "dark": "",
        "x-small": "",
        "fab": ""
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return function () {
            if (!_vm.confetti.show || _vm.confetti.opts.colors.length == 1) return;
            _vm.confetti.opts.colors.splice(i, 1);
            _vm.setConfetti();
          }.apply(null, arguments);
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiClose)
      }
    })], 1) : _vm._e()], 1);
  }), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "icon": "",
      "color": "primary",
      "disabled": !_vm.confetti.show
    },
    on: {
      "click": function ($event) {
        _vm.promptColor = {
          value: '#7fa8d7',
          callback: function (v) {
            _vm.confetti.opts.colors.push(v);
            _vm.setConfetti();
          }
        };
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  })], 1)], 2)], 1)], 1) : _vm.selected == 'STMP' ? _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "fill-height",
      "width": "600",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex align-center pa-3"
  }, [_c('div', {
    staticClass: "title pl-1"
  }, [_vm._v("Stamp")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0 mr-2",
    attrs: {
      "hide-details": "",
      "input-value": _vm.isActive('STMP')
    },
    nativeOn: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return function () {
          return _vm.isActive('STMP') && _vm.set({
            env_stamp: _vm.DEFAULT.env_stamp
          });
        }.apply(null, arguments);
      }
    }
  }), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v("Done")])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mx-auto",
    attrs: {
      "cols": "4",
      "sm": "3"
    }
  }, [_c('v-menu', {
    attrs: {
      "absolute": "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var on = _ref5.on,
          attrs = _ref5.attrs;
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [!_vm.order.skin.env_stamp ? _c('v-card', {
          staticStyle: {
            "outline": "2px dashed #E0E0E0 !important"
          },
          attrs: {
            "hover": ""
          }
        }, [_c('v-responsive', {
          staticClass: "white",
          attrs: {
            "aspect-ratio": 1
          }
        })], 1) : _c('v-responsive', _vm._g(_vm._b({
          staticClass: "overflow-visible",
          attrs: {
            "aspect-ratio": 1
          }
        }, 'v-responsive', attrs, false), on), [_c('img', {
          staticClass: "stamp-preview",
          attrs: {
            "width": "100%",
            "height": "100%",
            "src": _vm.order.skin.env_stamp
          }
        })])], 1)];
      }
    }])
  }, [_vm.order.skin.env_stamp || !_vm.noCustomMedia ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm.order.skin.env_stamp ? _c('v-list-item', {
    on: {
      "click": function ($event) {
        return _vm.set({
          env_stamp: null
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  }), _c('v-list-item-title', [_vm._v("Remove image")])], 1) : _c('v-list-item', {
    on: {
      "click": function ($event) {
        return _vm.promptImage(function (img) {
          return _vm.promptStamp = Object.assign({}, img, {
            scale: true,
            border: true
          });
        });
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  }), _c('v-list-item-title', [_vm._v("Upload image…")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('v-divider'), _vm.loadMediaStatus.pending || _vm.loadCustomMediaStatus.pending ? [_c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }), _c('v-spacer')] : [_c('div', {
    staticClass: "mt-2 mx-2 text--label-active"
  }, [_vm._v("Filters")]), _c('side-scroller', _vm._l(_vm.STAMP_FILTERS, function (_ref6, i) {
    var tag = _ref6[0],
      icon = _ref6[1];
    return _c('v-chip', {
      key: 'stmp-' + tag,
      staticClass: "ma-1",
      class: {
        'primary--text': _vm.stampFilter == i
      },
      attrs: {
        "filter": "",
        "input-value": _vm.stampFilter == i
      },
      on: {
        "click": function ($event) {
          _vm.stampFilter = _vm.stampFilter == i ? 0 : i;
        }
      }
    }, [_vm._v(" " + _vm._s(tag) + " "), icon ? _c('v-icon', {
      staticClass: "ml-1",
      domProps: {
        "innerHTML": _vm._s(icon)
      }
    }) : _vm._e()], 1);
  }), 1), _c('v-virtual-scroll-grid', {
    key: _vm.stampFilter,
    staticClass: "flex-grow-1",
    attrs: {
      "bench": "1",
      "items": _vm.stampFilter ? _vm.media.stamp.filter(function (x) {
        return x.tags.includes(_vm.STAMP_FILTERS[_vm.stampFilter][0]);
      }) : [null].concat(_vm.noCustomMedia ? [] : [null].concat(_vm.customMedia.stamp), _vm.media.stamp),
      "n": _vm.$vuetify.breakpoint.xsOnly ? 3 : 4,
      "aspect-ratio": 1,
      "padding": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref7) {
        var item = _ref7.item,
          index = _ref7.index;
        return [index == 0 && !_vm.stampFilter ? _c('v-card', {
          class: {
            active: !_vm.order.skin.env_stamp
          },
          style: {
            outline: _vm.order.skin.env_stamp ? '2px dashed #E0E0E0 !important' : null
          },
          attrs: {
            "hover": ""
          },
          on: {
            "click": function ($event) {
              return _vm.set({
                env_stamp: null
              });
            }
          }
        }, [_c('v-responsive', {
          staticClass: "white",
          attrs: {
            "aspect-ratio": 1
          }
        })], 1) : !_vm.noCustomMedia && index == 1 && !_vm.stampFilter ? _c('v-card', {
          staticStyle: {
            "outline": "2px dashed #E0E0E0 !important"
          },
          attrs: {
            "hover": "",
            "color": "grey lighten-5"
          },
          on: {
            "click": function ($event) {
              return _vm.promptImage(function (img) {
                return _vm.promptStamp = Object.assign({}, img, {
                  scale: true,
                  border: true
                });
              });
            }
          }
        }, [_c('v-responsive', {
          staticClass: "overflow-visible",
          attrs: {
            "aspect-ratio": 1
          }
        }, [_c('div', {
          staticClass: "fill-height d-flex align-center justify-center text-center text--label-active pa-3"
        }, [_vm._v(" Add custom image… ")]), _c('v-btn', {
          staticStyle: {
            "right": "-12px",
            "bottom": "-12px"
          },
          attrs: {
            "absolute": "",
            "fab": "",
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiUpload)
          }
        })], 1)], 1)], 1) : [_c('v-card', {
          staticClass: "v-card--link",
          class: {
            active: _vm.order.skin.env_stamp == item.url
          },
          attrs: {
            "flat": ""
          }
        }, [_c('v-responsive', {
          staticClass: "overflow-visible",
          attrs: {
            "aspect-ratio": 1
          }
        }, [_c('img', {
          staticClass: "stamp-preview",
          attrs: {
            "width": "100%",
            "height": "100%",
            "loading": "lazy",
            "src": item.url
          },
          on: {
            "click": function ($event) {
              return _vm.set({
                env_stamp: item.url
              });
            }
          }
        })])], 1), !item.default ? _c('v-btn', {
          staticStyle: {
            "right": "0",
            "bottom": "0"
          },
          attrs: {
            "absolute": "",
            "fab": "",
            "small": "",
            "loading": _vm.deletingMedia == item.name
          },
          on: {
            "click": function ($event) {
              _vm.deleteMedia('stamp', item.name).then(function (x) {
                if (x) {
                  if (_vm.order.skin.env_stamp == item.url) _vm.order.skin.env_stamp = null;
                }
              });
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "warning"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiDelete)
          }
        })], 1) : _vm._e()]];
      }
    }])
  })]], 2)], 1) : _vm.selected == 'MUS' ? _c('music-library-dialog', {
    attrs: {
      "is-active": _vm.isActive('MUS'),
      "no-custom-media": _vm.noCustomMedia,
      "value": _vm.order.skin.music
    },
    on: {
      "input": function (v) {
        return _vm.set({
          music: v
        });
      },
      "close": function ($event) {
        _vm.selected = null;
      }
    }
  }) : _vm.selected == 'ENV' ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "600",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "d-flex align-center pa-3 relative",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('div', {
    staticClass: "title pl-1"
  }, [_vm._v("Envelope colors")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "small": ""
    },
    on: {
      "click": function () {
        var bg = _vm.COLORS[Math.floor(Math.random() * _vm.COLORS.length)];
        _vm.set({
          env_background_color: bg,
          env_font_color: _vm.getBrightness(bg) < 160 ? '#FEFEFE' : '#1A237E'
        });
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiShuffleVariant)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Randomize")])], 1), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v("Done")])], 1), _c('div', {
    staticClass: "hidden-sm-and-up mb-4 px-4"
  }, [_c('div', {
    staticClass: "mx-auto d-flex justify-center",
    staticStyle: {
      "max-width": "300px",
      "aspect-ratio": "7 / 5",
      "position": "relative"
    }
  }, [_c('envelope', {
    key: _vm.order.skin.env_background_color + _vm.order.skin.env_font_color,
    staticStyle: {
      "position": "absolute",
      "inset": "-20% 0 -20% 0"
    },
    attrs: {
      "from": _vm.envFrom || '[&nbsp;sender&nbsp;name&nbsp;]',
      "to": _vm.envTo || '[&nbsp;recipient&nbsp;name&nbsp;]',
      "skin": _vm.order.skin
    }
  }), _vm.envLowContrast ? _c('div', {
    staticClass: "btn-tooltip persistent prominent bottom warning--text",
    staticStyle: {
      "top": "unset",
      "bottom": "8px"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" Low contrast warning ")], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "mx-2 flex-grow-1 flex-sm-grow-0",
    staticStyle: {
      "width": "144px"
    }
  }, [_c('div', {
    staticClass: "text-center text--label-active mb-2"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathEnvBackground)
    }
  }), _vm._v(" Background ")], 1), _c('v-expand-transition', [_vm.$vuetify.breakpoint.smAndUp || !_vm.showMoreColors ? _c('div', _vm._l(_vm.COLORS, function (color) {
    return _c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      key: color,
      staticClass: "ma-2",
      style: {
        'background': color,
        'border': _vm.order.skin.env_background_color == color ? '1px solid rgba(0, 0, 0, 0.12)' : null,
        'box-shadow': _vm.order.skin.env_background_color == color ? `0 0 8px 4px ${color} !important` : null
      },
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": _vm.orgHas('env_background_color') ? 1 : null
      },
      on: {
        "click": function ($event) {
          _vm.orgHas('env_background_color') || _vm.set({
            env_background_color: color
          });
        }
      }
    });
  }), 1) : _vm._e()])], 1), !_vm.showMoreColors ? _c('v-divider', {
    staticClass: "hidden-sm-and-up",
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hidden-xs-only flex-grow-1"
  }, [_c('div', {
    staticClass: "mt-8 mx-3 d-flex justify-center",
    staticStyle: {
      "aspect-ratio": "7 / 5",
      "position": "relative"
    }
  }, [_c('envelope', {
    key: _vm.order.skin.env_background_color + _vm.order.skin.env_font_color,
    staticStyle: {
      "position": "absolute",
      "inset": "-20% 0 -20% 0"
    },
    attrs: {
      "from": _vm.envFrom || '[&nbsp;sender&nbsp;name&nbsp;]',
      "to": _vm.envTo || '[&nbsp;recipient&nbsp;name&nbsp;]',
      "skin": _vm.order.skin
    }
  }), _vm.envLowContrast ? _c('div', {
    staticClass: "btn-tooltip persistent prominent bottom warning--text",
    staticStyle: {
      "top": "unset",
      "bottom": "8px"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" Low contrast warning ")], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "mx-2 flex-grow-1 flex-sm-grow-0 text-right",
    staticStyle: {
      "width": "144px"
    }
  }, [_c('div', {
    staticClass: "text-center text--label-active mb-2"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathEnvToFrom)
    }
  }), _vm._v(" Text ")], 1), _c('v-expand-transition', [_vm.$vuetify.breakpoint.smAndUp || !_vm.showMoreColors ? _c('div', _vm._l(_vm.COLORS, function (color) {
    return _c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      key: color,
      staticClass: "ma-2",
      style: {
        'background': color,
        'border': _vm.order.skin.env_font_color == color ? '1px solid rgba(0, 0, 0, 0.12)' : null,
        'box-shadow': _vm.order.skin.env_font_color == color ? `0 0 8px 4px ${color} !important` : null
      },
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": _vm.orgHas('env_font_color') ? 1 : null
      },
      on: {
        "click": function ($event) {
          _vm.orgHas('env_font_color') || _vm.set({
            env_font_color: color
          });
        }
      }
    });
  }), 1) : _vm._e()])], 1)], 1), _c('div', {
    staticClass: "pa-2 text-center"
  }, [_c('v-btn', {
    staticClass: "pl-2",
    staticStyle: {
      "text-transform": "unset",
      "letter-spacing": "unset"
    },
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showMoreColors = !_vm.showMoreColors;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    domProps: {
      "innerHTML": _vm._s(_vm.showMoreColors ? _vm.mdiMenuUp : _vm.mdiMenuDown)
    }
  }), _c('span', {
    staticClass: "text--label-active primary--text"
  }, [_vm._v(_vm._s(_vm.showMoreColors ? 'Hide' : 'Show') + " color pickers")])], 1)], 1), _c('v-expand-transition', [_vm.showMoreColors ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-color-picker', {
    staticStyle: {
      "max-width": "50%"
    },
    attrs: {
      "mode": "rgba",
      "value": _vm.vColorPickerValue(_vm.order.skin.env_background_color),
      "disabled": _vm.orgHas('env_background_color')
    },
    on: {
      "input": function (v) {
        return _vm.set({
          env_background_color: v
        });
      }
    }
  }), _c('v-divider', {
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "vertical": ""
    }
  }), _c('v-color-picker', {
    staticStyle: {
      "max-width": "50%"
    },
    attrs: {
      "mode": "rgba",
      "value": _vm.vColorPickerValue(_vm.order.skin.env_font_color),
      "disabled": _vm.orgHas('env_font_color')
    },
    on: {
      "input": function (v) {
        return _vm.set({
          env_font_color: v
        });
      }
    }
  })], 1) : _vm._e()])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "flex-grow-1 relative overflow-auto"
  }, [!_vm.isCancelled ? _c('div', {
    staticClass: "absolute overflow-visible d-flex flex-column pa-4 pl-8",
    staticStyle: {
      "grid-gap": "8px",
      "z-index": "2",
      "right": "0"
    }
  }, [_vm._t("top-right"), !(_vm.orgHas('page_background_color') && _vm.orgHas('page_background_img') && _vm.orgHas('open_effect')) ? _c('div', {
    staticClass: "btn-group btn-group-vertical d-flex flex-column"
  }, [!(_vm.orgHas('page_background_color') && _vm.orgHas('page_background_img')) ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    class: {
      active: _vm.isActive('BG')
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "red lighten-1"
    },
    on: {
      "click": function () {
        if (_vm.orgHas('page_background_img')) _vm.promptColor = {
          value: _vm.order.skin.page_background_color,
          eager: true,
          callback: function (v) {
            return _vm.set({
              page_background_color: v
            });
          }
        };else _vm.selected = 'BG';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImage)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.global.showHelp
    }
  }, [_vm._v(" Background" + _vm._s(_vm.orgHas('page_background_img') && !_vm.orgHas('page_background_color') ? ' color' : '') + " ")])], 1) : _vm._e(), !_vm.orgHas('open_effect') ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    class: {
      active: _vm.isActive('CF')
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "red lighten-1"
    },
    on: {
      "click": function ($event) {
        _vm.selected = 'CF';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiGrain)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.global.showHelp
    }
  }, [_vm._v("Confetti")])], 1) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "btn-group btn-group-vertical d-flex flex-column"
  }, [!_vm.orgHas('env_stamp') ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    class: {
      active: _vm.isActive('STMP')
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "amber darken-3"
    },
    on: {
      "click": function ($event) {
        _vm.selected = 'STMP';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathEnvStamp)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.global.showHelp
    }
  }, [_vm._v("Stamp")])], 1) : _vm._e(), !(_vm.orgHas('env_font_color') && _vm.orgHas('env_background_color')) ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    class: {
      active: _vm.isActive('ENV')
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "amber darken-3"
    },
    on: {
      "click": function ($event) {
        _vm.selected = 'ENV';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathEnvColor)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.global.showHelp
    }
  }, [_vm._v("Envelope colors")])], 1) : _vm._e(), !_vm.orgHas('env_font') ? _c('font-picker-btn', {
    ref: "font-picker-btn",
    attrs: {
      "fonts": _vm.FONTS,
      "left": true,
      "value": _vm.order.skin.env_font
    },
    on: {
      "input": function (v) {
        return _vm.set({
          env_font: v
        });
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref8) {
        var on = _ref8.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-top",
          class: {
            active: _vm.isActive('FONT')
          },
          attrs: {
            "fab": "",
            "dark": "",
            "color": "amber darken-3"
          }
        }, on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.iconPathEnvFont)
          }
        }), _c('span', {
          staticClass: "btn-tooltip left",
          class: {
            persistent: _vm.global.showHelp
          }
        }, [_vm._v("Envelope font")])], 1)];
      }
    }, {
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "flex-grow-0 d-flex align-center pa-3"
        }, [_c('div', {
          staticClass: "title pl-2",
          staticStyle: {
            "margin-top": "2px"
          }
        }, [_vm._v("Font")]), _c('v-spacer'), _c('v-switch', {
          staticClass: "mt-0 mr-2",
          attrs: {
            "hide-details": "",
            "input-value": _vm.isActive('FONT')
          },
          on: {
            "change": function ($event) {
              _vm.set({
                env_font: _vm.isActive('FONT') ? _vm.DEFAULT.env_font : _vm.FONTS.filter(function (x) {
                  return x != _vm.DEFAULT.env_font;
                })[Math.floor(Math.random() * (_vm.FONTS.length - 1))]
              });
            }
          }
        }), _c('v-btn', {
          attrs: {
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.$refs['font-picker-btn'].open = false;
            }
          }
        }, [_vm._v("Done")])], 1), _c('v-divider')];
      },
      proxy: true
    }], null, false, 3676974714)
  }) : _vm._e()], 1), !_vm.orgHas('music') ? _c('v-btn', {
    staticClass: "btn-top",
    class: {
      active: _vm.isActive('MUS')
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "lime darken-1",
      "input-value": _vm.selected == 'MUS'
    },
    on: {
      "click": function ($event) {
        _vm.selected = 'MUS';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMusic)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.global.showHelp
    }
  }, [_vm._v("Music")])], 1) : _vm._e(), !_vm.orgHasLogo ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "btn-top",
    class: {
      active: _vm.isActive('LOGO')
    },
    attrs: {
      "fab": "",
      "dark": "",
      "color": "blue-grey lighten-1"
    },
    on: {
      "click": function ($event) {
        _vm.selected = 'LOGO';
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTag)
    }
  }), _c('span', {
    staticClass: "btn-tooltip left",
    class: {
      persistent: _vm.global.showHelp
    }
  }, [_vm._v("Logo")])], 1) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "fill-height relative",
    class: {
      'theme-interactive': !_vm.isCancelled,
      'hover-logo': !_vm.orgHasLogo
    },
    staticStyle: {
      "padding-right": "72px",
      "z-index": "0",
      "min-height": "446px"
    },
    style: {
      'background-color': _vm.hideBackgroundConfetti ? null : _vm.order.skin.page_background_color
    }
  }, [_vm.order.skin.open_effect && !_vm.hideBackgroundConfetti ? _c('confetti', {
    key: _vm.order.skin.open_effect,
    staticClass: "absolute-fill overflow-hidden",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "effect": _vm.order.skin.open_effect,
      "active": true
    }
  }) : _vm._e(), _vm.order.skin.page_background_img && !_vm.hideBackgroundConfetti ? _c('card-background', {
    key: _vm.order.skin.page_background_img,
    attrs: {
      "src": _vm.order.skin.page_background_img
    }
  }) : _vm._e(), _c('div', {
    staticClass: "absolute ma-4 header-logo",
    class: {
      disabled: _vm.disableLogo
    },
    staticStyle: {
      "min-height": "64px",
      "min-width": "64px"
    },
    on: {
      "click": function ($event) {
        !_vm.disableLogo && _vm.click('logo');
      }
    }
  }, [_vm.order.skin.header_logo ? _c('img', {
    staticClass: "d-block",
    attrs: {
      "height": "64",
      "src": _vm.order.skin.header_logo
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "pa-4 fill-height mx-auto relative"
  }, [_c('envelope', {
    ref: "env",
    staticClass: "fill-height",
    attrs: {
      "from": _vm.envFrom,
      "to": _vm.envTo,
      "to-multiple-recipients": _vm.order.multiple_recipients,
      "skin": _vm.order.skin,
      "edit-stamp": !_vm.isCancelled && !_vm.orgHas('env_stamp'),
      "edit-from": !_vm.isCancelled && !_vm.disableFrom,
      "edit-to": !_vm.isCancelled && !_vm.order.multiple_recipients && !_vm.disableTo,
      "edit-to-multiple-recipients": !_vm.isCancelled && _vm.order.type != 'INVITATION' && !_vm.disableTo && !_vm.disableMultipleRecipients,
      "edit-to-multiple-recipients-label": `Send ${_vm.order.type == 'GROUP' ? 'the signed / completed' : 'this'} card to multiple people`,
      "edit-to-multiple-recipients-disabled": _vm.order.state == 'COMPLETED' && _vm.order.send_started_at && _vm.order.multiple_recipients && _vm.order.info.recipient_groups.filter(function (x) {
        return x.targets.some(function (y) {
          var _vm$deliveries;
          return (((_vm$deliveries = _vm.deliveries) === null || _vm$deliveries === void 0 ? void 0 : _vm$deliveries.byTarget[y.toLowerCase()]) || []).length;
        });
      }).length >= 2,
      "dirty": _vm.order.state != 'PENDING' || _vm.order.dirty.includes('envelope')
    },
    on: {
      "update:from": function (v) {
        return _vm.order.info.from = v || '';
      },
      "update:to": function (v) {
        return !_vm.order.multiple_recipients && (_vm.order.info.to = v || '');
      },
      "update:multiple-recipients": _vm.setMultipleRecipients,
      "click:stamp": function ($event) {
        return _vm.click('stamp');
      }
    },
    scopedSlots: _vm._u([_vm.order.skin.music || !_vm.isCancelled ? {
      key: "below",
      fn: function () {
        return [_c('div', {
          staticClass: "absolute-fill py-3 d-flex justify-center"
        }, [_vm.order.skin.music ? _c('div', {
          staticClass: "btn-group d-flex",
          staticStyle: {
            "max-width": "100%"
          }
        }, [_c('tooltip-btn', {
          attrs: {
            "msg": "Music preview",
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref9) {
              var on = _ref9.on;
              return [_c('audio-preview-btn', _vm._g({
                staticClass: "flex-shrink-1 overflow-hidden",
                class: {
                  'btn-group-right': !_vm.orgHas('music') && !_vm.isCancelled
                },
                attrs: {
                  "color": "primary",
                  "dark": "",
                  "height": _vm.$vuetify.breakpoint.smAndUp ? 56 : null,
                  "name": _vm.musicName,
                  "src": _vm.order.skin.music
                }
              }, on))];
            }
          }], null, false, 4183499713)
        }), !_vm.orgHas('music') && !_vm.isCancelled ? _c('tooltip-btn', {
          attrs: {
            "msg": "Remove music",
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref10) {
              var on = _ref10.on;
              return [_c('v-btn', _vm._g({
                staticClass: "btn-group-left px-2 px-sm-4",
                staticStyle: {
                  "min-width": "unset"
                },
                attrs: {
                  "rounded": "",
                  "color": "primary",
                  "dark": "",
                  "height": _vm.$vuetify.breakpoint.smAndUp ? 56 : null
                },
                on: {
                  "click": function ($event) {
                    return _vm.set({
                      music: null
                    });
                  }
                }
              }, on), [_c('v-icon', {
                domProps: {
                  "innerHTML": _vm._s(_vm.mdiClose)
                }
              })], 1)];
            }
          }], null, false, 2551823071)
        }) : _vm._e()], 1) : !_vm.orgHas('music') ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "rounded": "",
            "height": _vm.$vuetify.breakpoint.smAndUp ? 56 : null
          },
          on: {
            "click": function ($event) {
              _vm.selected = 'MUS';
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMusic)
          }
        }), _vm._v(" Click to add music… ")], 1) : _vm._e()], 1)];
      },
      proxy: true
    } : null], null, true)
  })], 1)], 1)]), !_vm.noFooter ? _c('div', {
    staticClass: "flex-grow-0 relative btn-group",
    staticStyle: {
      "z-index": "1"
    }
  }, [!_vm.isCancelled ? _c('tooltip-btn', {
    attrs: {
      "msg": `${_vm.global.showThemePresets ? 'Hide' : 'Show'} presets`,
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref11) {
        var on = _ref11.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticClass: "btn-group-left btn-group-bottom px-4",
          staticStyle: {
            "bottom": "100%"
          },
          attrs: {
            "absolute": "",
            "color": "grey lighten-5"
          },
          on: {
            "click": function ($event) {
              _vm.global.showThemePresets = !_vm.global.showThemePresets;
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "primary"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.global.showThemePresets ? _vm.mdiArrowCollapseDown : _vm.mdiArrowCollapseUp)
          }
        })], 1)];
      }
    }], null, false, 3989439604)
  }) : _vm._e()], 1) : _vm._e(), _c('v-expand-transition', [!_vm.noFooter && _vm.global.showThemePresets && !_vm.isCancelled ? _c('div', {
    staticClass: "grey lighten-5",
    staticStyle: {
      "z-index": "2",
      "box-shadow": "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)"
    }
  }, [_c('select-theme-ribbon', {
    staticClass: "overflow-auto pa-3",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "font-size": ".7rem",
      "width": "70",
      "order": _vm.order,
      "org-skin": _vm.orgSkin
    },
    on: {
      "input": function (v) {
        return _vm.set(Object.assign({}, v, {
          page_background_img: null
        }));
      }
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }